export const articles = [
  {
    id: 1,
    slug: 'asian-five-code-guide',
    title: '亚洲五码尺码对照完全指南：小白也能秒懂',
    excerpt: '亚洲五码是亚洲地区通用的尺码标准体系，了解亚洲五码与欧码、美码、英码的换算关系，是跨境购物的必修课。本文从零开始讲清亚洲五码的来龙去脉。',
    content: `亚洲五码是亚洲地区广泛使用的尺码标准，涵盖鞋码和服装尺码两大领域。对于经常在亚洲电商平台购物的消费者来说，理解亚洲五码的编码逻辑至关重要。

## 什么是亚洲五码？

亚洲五码并非一个官方标准名称，而是消费者对亚洲地区主流尺码体系的通俗称呼。它包括了以下几种常见尺码：

- 中国码（CN）：以脚长毫米数为基准，如235、240、245
- 日本码（JP）：同样以厘米数为单位，如23.5、24.0、24.5
- 韩国码（KR）：以毫米数为单位，范围通常在220-300之间
- 香港码（HK）：多采用欧洲码体系
- 台湾码（TW）：与中国码类似

## 亚洲五码与欧码的换算

欧码与亚洲五码的换算公式为：

**鞋码换算**：欧码 = (中国码 ÷ 5) × 2 + 1

举例：中国码240（即24.0cm）对应的欧码约为 (24 ÷ 5) × 2 + 1 ≈ 38.5，取整为38或39码。

**服装尺码换算**：亚洲服装尺码普遍比欧美小1-2个号。亚洲L码大致相当于欧美的M码。

## 亚洲五码与美码的换算

美码换算相对复杂，男女鞋有不同的换算逻辑：

- 男鞋：美码 = (中国码 - 220) ÷ 5 × 3 + 5
- 女鞋：美码 = (中国码 - 220) ÷ 5 × 3 + 4.5

举例：中国码260男鞋，美码约为 (260-220) ÷ 5 × 3 + 5 = 29，即美码8码左右。

## 亚洲五码与英码的换算

英码换算逻辑与美码类似但略有差异：

- 男鞋：英码 = (中国码 - 220) ÷ 5 × 3 + 4
- 女鞋：英码 = (中国码 - 220) ÷ 5 × 3 + 3

## 实际购物建议

1. 每个品牌的尺码可能存在偏差，建议参考具体品牌的尺码表
2. 量脚的最佳时间是下午或傍晚，此时脚部会略微膨胀
3. 购买运动鞋时建议选大半码，为运动时脚部膨胀留出空间
4. 左右脚尺寸可能不同，以较大的一只为准`,
    coverImage: 'https://readdy.ai/api/search-image?query=Asian%20shoe%20size%20conversion%20chart%20displayed%20on%20a%20clean%20minimalist%20wooden%20desk%20with%20measuring%20tape%2C%20warm%20natural%20lighting%2C%20soft%20shadows%2C%20elegant%20editorial%20photography%2C%20cream%20background&width=800&height=450&seq=article-cover-01&orientation=landscape',
    category: '鞋子尺码',
    categorySlug: 'shoes',
    createdAt: '2026-06-15',
    readTime: '8分钟',
    tags: ['亚洲五码', '尺码换算', '鞋码对照', '亚洲五码换算'],
    relatedIds: [2, 3, 4]
  },
  {
    id: 2,
    slug: 'shoe-size-conversion-table',
    title: '2026最新鞋码换算表：亚洲五码×欧码×美码×英码全对照',
    excerpt: '超全鞋码对照表来了！涵盖男女鞋码，亚洲五码、欧码、美码、英码一站式对照，再也不用担心买错鞋码。',
    content: `选购鞋子时，最让人头疼的就是尺码换算问题。不同国家、不同品牌使用的尺码标准各不相同，尤其是亚洲五码与欧美码之间的换算，更是让不少消费者感到困惑。

## 女鞋尺码对照表

| 脚长(mm) | 中国码 | 日本码 | 欧码 | 美码 | 英码 |
|---------|--------|--------|------|------|------|
| 220 | 34 | 22.0 | 35 | 4.5 | 2.5 |
| 225 | 35 | 22.5 | 35.5 | 5 | 3 |
| 230 | 36 | 23.0 | 36 | 5.5 | 3.5 |
| 235 | 37 | 23.5 | 37 | 6 | 4 |
| 240 | 38 | 24.0 | 38 | 6.5 | 4.5 |
| 245 | 39 | 24.5 | 38.5 | 7 | 5 |
| 250 | 40 | 25.0 | 39 | 7.5 | 5.5 |
| 255 | 41 | 25.5 | 40 | 8 | 6 |
| 260 | 42 | 26.0 | 41 | 9 | 7 |

## 男鞋尺码对照表

| 脚长(mm) | 中国码 | 日本码 | 欧码 | 美码 | 英码 |
|---------|--------|--------|------|------|------|
| 245 | 39 | 24.5 | 39 | 6.5 | 5.5 |
| 250 | 40 | 25.0 | 40 | 7 | 6 |
| 255 | 41 | 25.5 | 40.5 | 7.5 | 6.5 |
| 260 | 42 | 26.0 | 41 | 8 | 7 |
| 265 | 43 | 26.5 | 42 | 8.5 | 7.5 |
| 270 | 44 | 27.0 | 42.5 | 9 | 8 |
| 275 | 45 | 27.5 | 43 | 9.5 | 8.5 |
| 280 | 46 | 28.0 | 44 | 10 | 9 |
| 285 | 47 | 28.5 | 44.5 | 10.5 | 9.5 |
| 290 | 48 | 29.0 | 45 | 11 | 10 |

## 如何正确测量脚长

1. 准备一张白纸和一支笔
2. 光脚站在纸上，脚跟紧贴墙壁
3. 用笔沿脚的最长处画一条线
4. 用尺子量出长度即为脚长
5. 建议下午测量，此时脚部略微膨胀

## 选码小贴士

选购运动鞋时，建议比实际脚长多出5-8mm的空间；选购皮鞋时，多出3-5mm即可。如果是宽脚或高脚背，建议再选大半码。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Various%20shoe%20sizes%20and%20measuring%20tools%20arranged%20on%20a%20light%20wooden%20surface%2C%20ruler%20and%20measuring%20tape%2C%20warm%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20light&width=800&height=450&seq=article-cover-02&orientation=landscape',
    category: '鞋子尺码',
    categorySlug: 'shoes',
    createdAt: '2026-07-02',
    readTime: '6分钟',
    tags: ['亚洲五码', '鞋码对照表', '亚洲五码对照表', '尺码换算'],
    relatedIds: [1, 3, 5]
  },
  {
    id: 3,
    slug: 'clothing-size-conversion',
    title: '服装尺码亚洲五码对照：上衣、裤装、内衣全品类解析',
    excerpt: '亚洲服装尺码偏小是公认的事实。本文详解亚洲五码服装尺码与欧美尺码的对照关系，涵盖男女上衣、裤装、内衣等全品类。',
    content: `跨境购买服装时，尺码问题是最常见的退换货原因。亚洲五码服装尺码普遍比欧美尺码小1-2个号，了解其中的差异有助于准确选码。

## 女装上衣尺码对照

| 亚洲码 | 欧码 | 美码 | 胸围(cm) | 腰围(cm) |
|--------|------|------|----------|----------|
| S | XS | 2 | 80-84 | 62-66 |
| M | S | 4 | 84-88 | 66-70 |
| L | M | 6 | 88-92 | 70-74 |
| XL | L | 8 | 92-96 | 74-78 |
| XXL | XL | 10 | 96-100 | 78-82 |

## 男装上衣尺码对照

| 亚洲码 | 欧码 | 美码 | 胸围(cm) | 肩宽(cm) |
|--------|------|------|----------|----------|
| S | XS | XS | 88-92 | 42-44 |
| M | S | S | 92-96 | 44-46 |
| L | M | M | 96-100 | 46-48 |
| XL | L | L | 100-104 | 48-50 |
| XXL | XL | XL | 104-108 | 50-52 |

## 裤装尺码对照

| 亚洲码 | 欧码 | 美码 | 腰围(cm) | 臀围(cm) |
|--------|------|------|----------|----------|
| 28 | 42 | 28 | 71-73 | 89-91 |
| 29 | 44 | 29 | 73-76 | 91-93 |
| 30 | 46 | 30 | 76-79 | 93-95 |
| 31 | 48 | 31 | 79-81 | 95-97 |
| 32 | 50 | 32 | 81-84 | 97-99 |
| 33 | 52 | 33 | 84-86 | 99-101 |
| 34 | 54 | 34 | 86-89 | 101-103 |

## 购买建议

1. 亚洲品牌的L码穿着效果约等于欧美品牌的M码
2. 日本品牌的尺码普遍比中国品牌小半码
3. 韩国品牌的剪裁偏修身，建议选大一码
4. 购买前务必查看商品详情页的尺码表
5. 注意不同面料（如棉、羊毛、弹性面料）对尺码选择的影响`,
    coverImage: 'https://readdy.ai/api/search-image?query=Clothing%20size%20labels%20and%20measuring%20tape%20on%20a%20neutral%20fabric%20background%2C%20fashion%20design%20concept%2C%20warm%20beige%20tones%2C%20elegant%20soft%20lighting%2C%20minimalist%20editorial%20style&width=800&height=450&seq=article-cover-03&orientation=landscape',
    category: '服装尺码',
    categorySlug: 'clothing',
    createdAt: '2026-07-18',
    readTime: '7分钟',
    tags: ['亚洲五码', '服装尺码', '尺码对照', '亚洲尺码对照'],
    relatedIds: [1, 2, 4]
  },
  {
    id: 4,
    slug: 'kids-size-guide',
    title: '儿童鞋服尺码对照：亚洲五码童装童鞋选购指南',
    excerpt: '给孩子买鞋买衣服，尺码总拿不准？本文整理了亚洲五码童鞋童装与欧美码的完整对照表，让宝爸宝妈轻松选购。',
    content: `孩子的成长速度惊人，选购童装童鞋时尺码的选择尤为重要。亚洲五码童装体系与成人尺码体系有较大差异，本文详细解析。

## 童鞋尺码对照表

| 脚长(mm) | 中国码 | 欧码 | 美码 | 英码 | 建议年龄 |
|---------|--------|------|------|------|----------|
| 110 | 18 | 19 | 3.5 | 2.5 | 0-1岁 |
| 120 | 19 | 20 | 4.5 | 3.5 | 1-2岁 |
| 130 | 21 | 22 | 5.5 | 4.5 | 2-3岁 |
| 140 | 22 | 23 | 6.5 | 5.5 | 3-4岁 |
| 150 | 24 | 25 | 8 | 7 | 4-5岁 |
| 160 | 26 | 27 | 9.5 | 8.5 | 5-6岁 |
| 170 | 28 | 29 | 11 | 10 | 6-7岁 |
| 180 | 30 | 31 | 12.5 | 11.5 | 7-8岁 |
| 190 | 31 | 32 | 13.5 | 12.5 | 8-9岁 |
| 200 | 33 | 34 | 1.5 | 13.5 | 9-10岁 |
| 210 | 34 | 35 | 2.5 | 1 | 10-11岁 |
| 220 | 35 | 36 | 3.5 | 2 | 11-12岁 |

## 童装尺码对照表

| 身高(cm) | 亚洲码 | 欧码 | 美码 | 建议年龄 |
|----------|--------|------|------|----------|
| 50-60 | 60 | 56 | 0-3M | 新生儿 |
| 60-70 | 70 | 62 | 3-6M | 3-6月 |
| 70-80 | 80 | 74 | 6-12M | 6-12月 |
| 80-90 | 90 | 86 | 12-18M | 1-2岁 |
| 90-100 | 100 | 98 | 2T | 2-3岁 |
| 100-110 | 110 | 104 | 3T | 3-4岁 |
| 110-120 | 120 | 116 | 4T | 4-5岁 |
| 120-130 | 130 | 128 | 5 | 5-6岁 |
| 130-140 | 140 | 140 | 7 | 7-8岁 |
| 140-150 | 150 | 152 | 10 | 9-10岁 |
| 150-160 | 160 | 164 | 14 | 11-12岁 |

## 选购童鞋的特别提醒

1. 儿童脚部发育快，建议每3-4个月重新测量一次脚长
2. 童鞋内长应比脚长大0.5-1cm，给脚趾留出活动空间
3. 学步期宝宝选鞋底柔软防滑的鞋子
4. 避免购买过大的鞋子"将就穿"，会影响孩子脚部发育`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20children%20shoes%20and%20clothing%20with%20size%20measuring%20tools%20on%20a%20warm%20wooden%20floor%2C%20soft%20pastel%20colors%2C%20cozy%20family%20atmosphere%2C%20natural%20window%20light%2C%20gentle%20cream%20background&width=800&height=450&seq=article-cover-04&orientation=landscape',
    category: '童装尺码',
    categorySlug: 'kids',
    createdAt: '2026-08-01',
    readTime: '6分钟',
    tags: ['亚洲五码', '童装尺码', '童鞋尺码', '儿童尺码对照'],
    relatedIds: [1, 2, 3]
  },
  {
    id: 5,
    slug: 'online-shopping-size-tips',
    title: '网购选码终极技巧：亚洲五码用户避坑指南',
    excerpt: '网购最怕尺码不合！整理了10条超实用的亚洲五码选购经验，从测量方法到品牌差异，帮你告别退换货烦恼。',
    content: `网购虽然方便，但尺码问题始终是最大的痛点。根据电商平台数据，约30%的退换货原因是尺码不合适。掌握以下亚洲五码选购技巧，能大幅降低踩坑概率。

## 十大选码技巧

### 1. 量准自己的尺寸
不要凭记忆或感觉选码。用软尺准确测量脚长、胸围、腰围、臀围等关键数据，并记录下来。建议每半年重新测量一次。

### 2. 了解目标品牌尺码
同一尺码在不同品牌间可能有显著差异。日系品牌偏小，欧美品牌偏大，购买前务必查看该品牌的具体尺码表。

### 3. 认真阅读商品评价
尤其是关于"偏大"还是"偏小"的评价。如果多数买家反映该款偏小，就需要选大一码。

### 4. 善用尺码推荐工具
许多电商平台提供智能尺码推荐功能，输入身高体重即可获得推荐。虽然不完全准确，但可作为参考。

### 5. 注意鞋型差异
运动鞋、皮鞋、凉鞋的选码逻辑不同。运动鞋建议选大半码，皮鞋合脚即可，凉鞋则可适当偏小。

### 6. 关注材质特性
真皮鞋会随着穿着逐渐变松，初期稍紧属正常。帆布鞋基本不会变形，需确保初次上脚就舒适。

### 7. 利用免费退换货服务
不确定尺码时，可同时购买相邻两个尺码，试穿后留下合适的，退回另一双。

### 8. 亚洲五码换算速记法
记住核心公式：亚洲五码 ≈ 欧码 - 1.5 ≈ 美码（男）+ 6 ≈ 英码（男）+ 7

### 9. 儿童选码留余地
孩子的脚和身体都在快速发育，童鞋内长应比脚长大0.5-1cm，童装可适当选大一号。

### 10. 保留购买记录
记录每次成功购买品牌、品类和尺码，形成个人尺码数据库，下次同品牌直接参考。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Online%20shopping%20on%20laptop%20with%20measuring%20tape%20and%20size%20chart%20beside%2C%20modern%20home%20office%20desk%2C%20warm%20ambient%20light%2C%20cozy%20atmosphere%2C%20clean%20minimalist%20photography&width=800&height=450&seq=article-cover-05&orientation=landscape',
    category: '选码技巧',
    categorySlug: 'tips',
    createdAt: '2026-08-08',
    readTime: '5分钟',
    tags: ['亚洲五码', '网购技巧', '选码指南', '尺码换算'],
    relatedIds: [1, 2, 3]
  }
];

export const categories = [
  { name: '鞋子尺码', slug: 'shoes', icon: 'ri-footprint-line', description: '男女鞋码对照，涵盖运动鞋、皮鞋、凉鞋等全品类' },
  { name: '服装尺码', slug: 'clothing', icon: 'ri-t-shirt-line', description: '上衣、裤装、内衣、外套尺码全解析' },
  { name: '童装尺码', slug: 'kids', icon: 'ri-bear-smile-line', description: '从新生儿到大童，童鞋童装一站式对照' },
  { name: '选码技巧', slug: 'tips', icon: 'ri-lightbulb-flash-line', description: '网购选码实用技巧，告别退换货烦恼' }
];